import React from 'react'
import Dropzone from 'react-dropzone'
import './upload.css'
import axios from 'axios'
import Button from 'components/Button'
import { GET_IMAGES } from 'operations/Object'
import { Query } from 'react-apollo'

const UploadContext = React.createContext(true)

class UploadProvider extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            url: null,
            files: [],
            count: 0,
            completed: [],
            isActive: false,
            thumbnails: [],
            progress: {}
        }

        this.onDrop = this.onDrop.bind(this)
        this.onCancel = this.onCancel.bind(this)
        this.onDragEnter = this.onDragEnter.bind(this)
        this.onDragLeave = this.onDragLeave.bind(this)
        this.handlePost = this.handlePost.bind(this)

    }


    onDragEnter() {
        this.setState({
            isActive: true
        })
    }

    onDragLeave() {
        this.setState({
            isActive: false
        });
    }

    onDrop(files) {
        const url = URL.createObjectURL(files[0])
        this.setState({
            url,
            files,
            count: this.state.count + files.length,
            isActive: false
        }, () => {
            this.handlePost()
        });
    }

    onCancel() {
        this.setState({
            url: null,
            files: [],
            count: 0,
            completed: [],
            isActive: false,
            thumbnails: [],
            progress: {}
        });
    }

    componentWillUnmount() {
        // Make sure to revoke the data uris to avoid memory leaks
        const {files} = this.state;
        for (let i = files.length; i >= 0; i--) {
            const file = files[0];
            if (file) {
                URL.revokeObjectURL(file.preview);
            }
        }
    }

    handlePost() {
 
        this.state.files.map((file, i) => {
            const data = new FormData()
            const preview = URL.createObjectURL(file)
            data.append('files', file, file.name)

            // setTimeout(() => {
            //     this.setState({
            //         completed: [
            //             ...this.state.completed,
            //             file.name
            //         ]
            //     })
            // }, 1500);

            return axios({
                method: 'POST',
                // url: process.env.NODE_ENV === 'development' ? 'http://localhost:4002/upload' : 'https://upload.tueri.io',
                url: 'https://upload.tueri.io',
                data,
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('accessToken') || null
                },
                onUploadProgress: (event) => {

                    const progress = this.state.progress
                    console.log(event)
                    progress[file.name] = { total: event.total, loaded: event.loaded }
                    this.setState({
                        progress
                    })
                    return null
                }
            })
            .then(response => {
                this.setState({
                    url: preview,
                    completed: [
                        ...this.state.completed,
                        response.data[0].originalName
                    ],
                    thumbnails: [this.state.thumbnails, preview]
                })
            })
            .catch(err => {
                console.log(err)
            })

        })
        
    }

    render() {

        const { isActive, url, files, completed, count, progress } = this.state

        let progressTotal = 0
        let progressLoaded = 0
        // console.log(progress)
        Object.keys(progress).map(file => {
            progressTotal += progress[file].total
            progressLoaded += progress[file].loaded
            return null
        })

        const progressPercent = progressLoaded > 0 ? Math.round(progressLoaded / progressTotal * 100) : 0;

        // console.log(progress, progressPercent)
        return(
            <UploadContext.Provider
                value={{
                    files: this.state.files
                }}
            >
                <Dropzone
                    onDrop={ this.onDrop }
                    onDragEnter={ this.onDragEnter }
                    onDragLeave={ this.onDragLeave }
                    style={{ position: 'relative', height: '100%' }}
                    disableClick
                >
                    { isActive && <div className='upload__container'>Drop files...</div> }
                    {
                        files.length && completed.length < count ? (
                            <div className='uploader'>
                                <div className='uploader__placeholder' style={{ backgroundImage: `url(${ url })` }} />
                                <div className='uploader__details'>
                                    <div className='uploader__title'>Uploading to library</div>
                                    <div className='uploader__count'>{ completed.length + 1 } of { count }</div>
                                    <Button className='uploader__button' onClick={ this.onCancel }>Cancel</Button>
                                </div>
                                <div className='uploader__progress'>
                                    <div className='uploader__progress--bar' style={{ width: `${progressPercent}%` }} />
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        completed.length === count && count > 0 ? (
                            <div className='uploader__complete'>
                                <button className='uploader__close' onClick={ this.onCancel }><i className='material-icons'>close</i></button>
                                <div className='uploader__title'>{ count } { count > 1 ? 'items' : 'item' } uploaded</div>
                                <div className='uploader__placeholder' style={{ backgroundImage: `url(${url})` }} />
                                {/* <Button className='uploader__button' onClick={ this.onCancel }>Add to album</Button> */}
                                <Query query={ GET_IMAGES }>
                                    {({ loading, error, data, refetch }) => {
                                        if (loading) return 'Loading...';
                                        if (error) return `Error! ${error.message}`;
                                        refetch()
                                        return null
                                    }}
                                </Query>
                            </div>
                        ) : null
                    }
                    { this.props.children }
                    
                </Dropzone>
            </UploadContext.Provider>
        )

    }

}

export {
    UploadContext,
    UploadProvider
}


// WEBPACK FOOTER //
// ./src/providers/Upload/index.js